module.exports = __webpack_public_path__ + "media/newstyle/images/book-1-b6aa42126951aeb98da391d446ec841d.png";